import { __awaiter, __generator } from "tslib";
import { WixOOISDKAdapter } from '@wix/bookings-adapter-ooi-wix-sdk';
import Experiments from '@wix/wix-experiments';
import { BiLogger } from '../bi-logger/bi-logger';
import { WidgetName } from '../bi-logger/bi.const';
import { WidgetServices } from '../platform/platform-services';
import { BookButtonViewModel } from './book-button.view-model';
export var createWidgetController = function (_a) {
    var compId = _a.compId, config = _a.config, $w = _a.$w, appParams = _a.appParams, platformAPIs = _a.platformAPIs, wixCodeApi = _a.wixCodeApi;
    return __awaiter(void 0, void 0, void 0, function () {
        var widgetProps, widgetServices, $widget, initialControllerAPI;
        return __generator(this, function (_b) {
            widgetProps = {};
            widgetServices = new WidgetServices(widgetProps);
            $widget = widgetServices.get$widget($w);
            initialControllerAPI = {};
            $widget.onPropsChanged(function () { });
            return [2 /*return*/, {
                    pageReady: function () { return __awaiter(void 0, void 0, void 0, function () {
                        var isSSR, experiments, wixSdkAdapter, biLogger;
                        return __generator(this, function (_a) {
                            isSSR = wixCodeApi.window.rendering.env === 'backend';
                            experiments = new Experiments({
                                scope: 'bookings-viewer-script',
                                baseUrl: isSSR ? 'https://wix.com' : '',
                            });
                            wixSdkAdapter = new WixOOISDKAdapter(wixCodeApi, platformAPIs, appParams, compId, experiments);
                            biLogger = new BiLogger(wixSdkAdapter, WidgetName.BOOK_BUTTON);
                            biLogger.sendWidgetLoad();
                            new BookButtonViewModel({
                                wixCodeApi: wixCodeApi,
                                platformAPIs: platformAPIs,
                                $button: $w('#bookButton'),
                                controllerConfig: config,
                                biLogger: biLogger,
                                experiments: experiments,
                            });
                            return [2 /*return*/];
                        });
                    }); },
                    exports: function () {
                        return widgetServices.generateControllerAPI($widget, initialControllerAPI);
                    },
                }];
        });
    });
};
//# sourceMappingURL=book-button.controller.js.map